var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72475 5.01921C3.07312 5.62429 2.63672 6.60607 2.63672 8.14616V14.8545C2.63672 16.3945 3.07312 17.3763 3.72475 17.9814C4.38601 18.5954 5.38231 18.9274 6.70963 18.9274H16.293C17.6203 18.9274 18.6165 18.5954 19.2779 17.9814C19.9295 17.3763 20.3659 16.3945 20.3659 14.8545V8.14616C20.3659 6.60607 19.9295 5.62429 19.2779 5.01921C18.6165 4.40518 17.6203 4.07324 16.293 4.07324H6.70963C5.38231 4.07324 4.38601 4.40518 3.72475 5.01921ZM2.7466 3.96581C3.76242 3.02255 5.16196 2.63574 6.70963 2.63574H16.293C17.8407 2.63574 19.2402 3.02255 20.256 3.96581C21.2815 4.91803 21.8034 6.33208 21.8034 8.14616V14.8545C21.8034 16.6686 21.2815 18.0826 20.256 19.0348C19.2402 19.9781 17.8407 20.3649 16.293 20.3649H6.70963C5.16196 20.3649 3.76242 19.9781 2.7466 19.0348C1.72115 18.0826 1.19922 16.6686 1.19922 14.8545V8.14616C1.19922 6.33208 1.72115 4.91803 2.7466 3.96581Z",
    fill: "#18181B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5561 7.00588C18.7989 7.31998 18.741 7.77138 18.427 8.01408L13.111 12.1218C12.1619 12.8551 10.8373 12.8551 9.88822 12.1218L4.57229 8.01408C4.25817 7.77138 4.2003 7.31998 4.44302 7.00588C4.68573 6.69177 5.13712 6.63389 5.45123 6.87661L10.7671 10.9842C11.1985 11.3177 11.8007 11.3177 12.232 10.9842L17.548 6.87661C17.8621 6.63389 18.3135 6.69177 18.5561 7.00588Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2bf3a1b0d8407f7e4f2731e021ac6c48.svg";
export { ForwardRef as ReactComponent };